import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import bem from 'utils/bem';
import Page from '../../pages/Page';
import Text from 'components/Text';
import ShopItemTeaser, { ShopItemTeaserSkeleton } from 'components/ShopItemTeaser';
import SlideDown from 'components/SlideDown';
import Model from '../../../model';
import './index.sass';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import TeaserPhoto from 'components/TeaserPhoto';
import { formatPrice } from 'utils/format';
import useCart from 'components/CartWidget/useCart';
import Icon from 'components/Icon';
import { useNavigate } from 'react-router';
import faq from './faq';
import slider from './slider';
import MobileSlider from 'components/Slider/MobileSlider';
import { useMobile } from 'utils/media';
import Slider from 'components/Slider';
const sliderContext = require.context('./slider/', false, /\.jpg$/);

const {cnBlock, el} = bem('secret-santa');

const SecretSanta = () => {
  const { oneItemData } = Model.shop;

  return (
    <Page className={ cnBlock() } showHeader={ false }>
      <div id='top'>
        <div className='top-text'>
          <Text serif tag='p'>
            На протяжении нескольких лет в сообществе проекта Otvet.co существовала и развивалась традиция «Тайного
            Санты». В обмене подарками, в исполнении желаний участвовали за эти годы несколько сотен человек. Знак
            внимания, готовность позаботиться о ком-то и неожиданно для себя открыть, что кто-то готов уделить внимание
            тебе самому — чем не предновогоднее чудо.
          </Text>
          <Text serif tag='p'>
            Традиция «Тайного Санты» легла в основу подарочных наборов, которые мы ежегодно готовим в преддверии Нового
            года. В каждом наборе: книга посланий Вероники Сидоровой «Новые письма к тебе» и подарки — аксессуары,
            бьюти-продукты, девайсы, одежда. Что попадется именно вам? Распорядится случай.
          </Text>
        </div>
        <div className='top-image'>
          <div className='top-image__shadow' />
          <div className='top-image__bg' />
        </div>
      </div>
      <div className='title title--trust'>
        <Text serif>Доверишься?</Text>
      </div>
      <div className='photo'>
        <div className='photo__shadow' />
        <div className='photo__bg' />
      </div>
      <div className='secret-santa-quote'>
        <div className='secret-santa-quote__shadow' />
        <div className='col'>
          <Text serif>
            Мы часто говорим о навыке слушать: слушать сердце, интуицию, свое тело, эмоции. Уметь слушать в нашей
            трактовке значит уметь замечать, следовать, доверять. Я знаю, что Otvet.co за годы работы сервиса стал
            путеводным маячком для уже сотен клиентов и помог сделать жизнь лучше, чуть легче. Мы очень ценим это
            доверие
            и очень постарались, чтобы вас удивить.
          </Text>
        </div>
        <div className='col'>
          <Text serif>
            Мы собрали для вас особенные наборы и разбили их на несколько категорий: для тела, для уюта, для дома.
            Выбирая
            набор по ощущению, которое хотелось бы от него получить, вы не будете знать, что внутри. Внутри красивого
            пакета с посланием обязательно будет книга и изделие, вещь, в разы превышающая стоимость покупки.
            Доверишься?
          </Text>
          <Text serif className='veronika-sign' tag='div'>
            Твоя Вероника
          </Text>
        </div>
      </div>
      <div className='products'>
        <Suspense fallback={ <ShopItemTeaserSkeleton /> }>
          <Product resource={ oneItemData('secret_santa') } />
        </Suspense>
      </div>
      <div className='title box-slider--title'>
        <Text serif>Один из наборов может стать твоим</Text>
      </div>
      <div className='box-slider'>
        <BoxSlider />
      </div>
      <div className='title title--faq'>
        <Text serif>FAQ</Text>
      </div>
      <div className='faq'>
        { faq.map((faqItem, index) =>
          <SlideDown key={ index } answer={ faqItem.answer } question={ faqItem.question } />
        ) }
      </div>
      <div className='feedback'>
        <div className='feedback__shadow' />
        <Text serif tag='div'>По всем вопросам будем рады ответить вам</Text>
        <Text serif><a href='mailto:kurs@otvet.co' target={ '_blank' }>hello@otvet.co</a></Text>
      </div>
    </Page>
  )
}

const { block: prBlock, el: prEl } = bem('shop-item-teaser')

const Product = ({ resource }) => {
  const item = resource.read();
  const { id, name, price, url, isDigital, soonActive, amount } = item.data;
  const { photo } = item;
  return (
    <CartButton id={ id } soonActive={ soonActive } maxAmount={ amount } >
      <div className={ prBlock() }>
        <div className={ prEl('top-block') }>
          <div className={ prEl('photo') }>
            <TeaserPhoto src={ photo } />
          </div>
          <div className={ prEl('title') }>
            <Text serif>{ name }</Text>
          </div>
        </div>
        <div className={ prEl('price-block') }>
          <Text>{ formatPrice(price) }</Text>
          { !isDigital && <Icon name={'shopping-cart'}/> }
        </div>
      </div>
    </CartButton>
  )
}

const BoxSlider = () => {
  const { isMobile } = useMobile();
  const BoxSlider = isMobile ? MobileSlider : Slider;

  const rSlides = slider.map((description, index) => {
    const img = sliderContext(`./${index + 1}.jpg`);
    return <BoxShopItemTeaser photo={img.__esModule ? img.default : img} description={description} />
  })

  return <BoxSlider items={rSlides} number={2} />
}

const BoxShopItemTeaser = ({photo, description}) => {
  const [ maxHeight, setMaxHeight ] = useState('auto');
  const maxHeightRef = useRef((node) => {
    if (!node) { return; }
    if (maxHeight < node.clientHeight) {
      setMaxHeight(node.clientHeight);
    }
  })
  return (
    <div className={ prBlock() } >
      <div ref={maxHeightRef} style={{height: `${maxHeight}px`}}>
        <div className={ prEl('top-block') }>
          <div className={ prEl('photo') }>
            <TeaserPhoto img={ photo } />
          </div>
          <div className={ prEl('description') }>
            <Text dangerouslySetInnerHTML={ { __html: description } } />
          </div>
        </div>
      </div>
    </div>
  )
}

const CartButton = ({ id, maxAmount, soonActive, children }) => {
  const { updateItem } = useCart(id);
  const navigate = useNavigate();

  const disabled = maxAmount <= 0 || soonActive;

  const onButtonClick = (e) => {
    e.preventDefault();
    if (maxAmount <= 0 || soonActive) {
      return;
    }
    updateItem();
    setTimeout(() => {
      navigate('/cart');
    }, 500)
  }

  if (disabled) { return null; }

  return (
    <div onClick={ onButtonClick }>
    { children }
    </div>
  )
}

export default observer(SecretSanta);
